<ag-grid-angular
  class="ag-theme-aux document-library-table tabular-nums"
  domLayout="autoHeight"
  [gridOptions]="$any(gridOptions$ | async)"
  (gridReady)="onGridReady($event)"
  [context]="getGridContext()"
  [rowSelection]="'multiple'"
  [suppressRowClickSelection]="true"
  [quickFilterText]="formGroup.controls.search.valueChanges | async"
  (rowSelected)="rowSelectedHandler($event)"
  [overlayNoRowsTemplate]="overlayNoRowsTemplate"
  [loadingCellRenderer]="loadingCellRenderer"
  (viewportChanged)="onWindowScroll()"
  (gridSizeChanged)="gridSizeChanged()"
>
</ag-grid-angular>
<aux-pagination-panel [gridApi]="gridAPI" (paginationChange)="paginationChange()" ></aux-pagination-panel>
